import { useEffect, useState } from 'react'
import { createPosition } from '../use-position'
import { Checkbox } from 'components'
import { Menu } from './menu'
import { Palette } from './palette'
import { Tile } from './tile'
import { Container, EditWindow, TileDetailsContainer, Board, Row, Color } from './main-styles'

const template = {
  bgColor: '#573',
  solid: false,
  position: { x: 0, y: 0 }
}

const TileDetails = ({ color, solid, setColor, setDoCollide, ...rest }) => {
  const handleDoCollide = ({ target: { checked } }) => {
    setDoCollide(checked)
  }

  const handleColor = (color) => {
    setColor(color)
  }

  return (
    <TileDetailsContainer>
      <Color
        background={color}
        color={color}
        position={{ width: 40, height: 40, x: 0, y: 0 }}
        className={solid ? 'solid' : ''}
      />
      <Checkbox label="is solid?" value={solid} onChange={handleDoCollide} />
      <Palette onChange={handleColor} />
    </TileDetailsContainer>
  )
}

const MapTile = ({ position, bgColor, ...rest }) => {
  const p = createPosition({ ...position, height: 20, width: 20 })
  return <Tile background={bgColor} position={p} {...rest} />
}

const setLocal = (db, data) => {
  localStorage.setItem(db, JSON.stringify(data))
}

const getLocal = (db) => {
  const local = localStorage.getItem(db)

  return local
    ? JSON.parse(local)
    : {
        grid: 20,
        cols: 30,
        rows: 15,
        tiles: [[template]]
      }
}

export const BarflyMapEditor = () => {
  const [tile, setTile] = useState(template)
  const [tiles, setTiles] = useState(getLocal('barfly').tiles)
  const [map, setMap] = useState(getLocal('barfly'))
  const [solid, setDoCollide] = useState()
  const [color, setColor] = useState('#573')

  const updateMap = () => {
    const newMap = [...tiles]
    while (newMap.length < map.rows) {
      newMap.push([])
    }
    setTiles(newMap)
  }

  useEffect(() => {
    updateMap()
  }, [map])

  useEffect(() => {
    setTile({ ...tile, color, solid })
  }, [color, solid])

  const addTile = ({ clientX }, row) => {
    const rows = [...tiles]
    const arry = rows[row]
    const col = Math.ceil(clientX / map.grid)
    if (arry.length < map.cols) {
      while (arry.length < map.cols) {
        arry.push({})
      }
    }
    const tileToEdit = arry[col - 1]
    arry[col - 1] = { ...template, solid, bgColor: color }
    setTiles(rows)
    setTile({ tileToEdit, color, solid, row, col: col - 1 })
  }

  const handleCollide = ({ target: { checked } }) => {
    console.log({ checked })
    setDoCollide(checked)
  }

  const handleMenuChange = (change, data) => {
    switch (change) {
      case 'color':
        return setColor(data)
      case 'details':
        return handleCollide(data)
      default:
        return true
    }
  }

  const getParams = (tile, index, row) => {
    return {
      ...tile,
      position: {
        x: index * 20,
        y: row * 20
      }
    }
  }

  useEffect(() => {
    setLocal('barfly', { ...map, tiles })
  }, [tiles])

  return (
    <Container>
      <Menu
        onChange={handleMenuChange}
        config={map}
        color={color}
        solid={solid}
      />
      <EditWindow>
        <Board>
          {tiles.map((row, r) => (
            <Row
              key={r}
              onClick={(ev) => addTile(ev, r)}
              width={map.cols * map.grid}
              height={map.grid}
            >
              {row.map((tile, i) => (
                <MapTile key={`${r}_${i}`} {...getParams(tile, i, r)} />
              ))}
            </Row>
          ))}
        </Board>
        <TileDetails
          {...tile}
          map={map}
          update={setTile}
          setColor={setColor}
          setDoCollide={setDoCollide}
          setMap={setMap}
        />
      </EditWindow>
    </Container>
  )
}
